import { render, staticRenderFns } from "./inventoryStockTreeMapWidget.vue?vue&type=template&id=dd0ed012&"
import script from "./inventoryStockTreeMapWidget.vue?vue&type=script&lang=js&"
export * from "./inventoryStockTreeMapWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports